import { t } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '@/components/auth-layout';
import { ForgotPasswordForm } from '@/features/auth/password/forgot-form';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { sanitizeRedirect } from '@/lib/routes';

/**
 * The "I forgot my password" route.
 *
 * Public, and deliberately without the session probe the login and register routes run:
 * someone who is already signed in may still want to change a password they no longer
 * remember, and the e-mail link can be opened in a browser that happens to have a session.
 */
export const Route = createFileRoute('/_auth/forgot-password')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: sanitizeRedirect(search.redirect),
  }),
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  useDocumentTitle(t('忘记密码'));
  const { redirect: redirectTo } = Route.useSearch();

  return (
    <AuthLayout title={t('忘记密码')} subtitle={t('验证账号后设置新密码')}>
      <ForgotPasswordForm redirectTo={redirectTo} />
    </AuthLayout>
  );
}
